<template>
<main class="projects">
  <gallery v-for="(project, index) in projects" :key="index" :index="index" :project="project" />
</main>
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  components: {
    Gallery
  },
  computed: {
    projects() {
      return this.$store.state.projects
    }
  },
  metaInfo() {
    return {
      title: '– Projects',
    }
  },
}
</script>

<style lang="scss" scoped>
.projects {
    padding: 0 !important;
    height: 100% !important;
    overflow-y: auto;
    scroll-snap-type: y mandatory;
}
</style>
